import { STREAMING_TYPE } from "./IQuoteStreamRepo";
import QuoteRequestMapper from "./QuoteRequestMapper";
import QuoteResponseMappper from "./QuoteResponseMappper";
class QuoteStreamRepo {
    constructor(stream) {
        this.stream = stream;
        this.requestMapper = new QuoteRequestMapper();
        this.responseMapper = new QuoteResponseMappper();
        this.listenerMap = new Map();
        this.callbackIdCounter = 0;
        this.symbols = [];
        this.symbolsMini = [];
    }
    streamQuote(streaming_type, subscribe, listener, symbols, streamKey) {
        if (!(symbols === null || symbols === void 0 ? void 0 : symbols.length))
            return;
        const classSymbols = streaming_type === STREAMING_TYPE.QUOTE ? this.symbols : this.symbolsMini;
        const generatedID = this.manageStreamArray(subscribe, streamKey, listener, symbols, classSymbols, streaming_type);
        const req = this.requestMapper.formatRequest(classSymbols, subscribe, streaming_type);
        const reqPayload = {
            payload: req,
            message: (e) => {
                this.streamRespCallback(e, streamKey, generatedID);
            },
        };
        this.stream.WSRequest(reqPayload);
    }
    streamRespCallback(e, streamKey, generatedID) {
        let currentListner = this.listenerMap.get(generatedID);
        this.responseMapper.formatResponse(e, streamKey, currentListner);
    }
    manageStreamArray(subscribe, streamKey, listener, symbols, classSymbols, streaming_type) {
        if (subscribe) {
            // Add new symbols
            for (const sym of symbols) {
                if (!classSymbols.includes(sym)) {
                    classSymbols.push(sym);
                }
            }
            // Generate a new internal ID
            const newId = `cb_${++this.callbackIdCounter}`;
            // Register callback
            this.listenerMap.set(newId, {
                id: newId,
                listener,
                streamKey,
                symbols,
                streaming_type,
            });
            return newId;
        }
        else {
            // Find and remove matching callback
            const existingEntry = Array.from(this.listenerMap.entries()).find(([, val]) => val.listener.toString() === listener.toString() &&
                val.streaming_type === streaming_type &&
                JSON.stringify(val.streamKey) === JSON.stringify(streamKey));
            if (existingEntry) {
                this.listenerMap.delete(existingEntry[0]);
            }
            // Remove symbols if unused by any other callback
            for (const sym of symbols) {
                const count = Array.from(this.listenerMap.values()).filter((cbItem) => cbItem.symbols.includes(sym) &&
                    cbItem.streaming_type === streaming_type &&
                    JSON.stringify(cbItem.streamKey) === JSON.stringify(streamKey)).length;
                if (count === 0) {
                    const index = classSymbols.indexOf(sym);
                    if (index !== -1) {
                        classSymbols.splice(index, 1);
                    }
                }
            }
            return null;
        }
    }
}
export default QuoteStreamRepo;
